<template>
  <div class="wrap">
    <div class="backgroundDiv">
      <div class="topDiv">
        <div class="titleDiv">
          <span class="title">防伪查询</span>
        </div>
        <div class="logoDiv">
          <img class="logo" src="../assets/logo.png" alt="">
        </div>
      </div>
      <div class="middleDiv">
        <div class="borderDiv">
          <div class="emtpyDiv"></div>
          <img class="scanSrc" src="../assets/scan.png" alt="" @click="scanClick">
          <div class="scanText">
            <p>扫描包装上的二维码</p>
            <p>查询产品真伪</p>
          </div>
        </div>
      </div>
      <div class="endDiv">
        <img class="sign" src = "../assets/sign.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import axios from 'axios'
export default {
  data () {
    return {
      code: '',
      screenHeight: ''
    }
  },
  created () {
    this.screenHeight = window.document.body.offsetHeight
    axios({
      method: 'get',
      url: window.config.serverUrl + '/scan-service/wx/getSign?url=' + location.href.split('#')[0]
    }).then((res) => {
      wx.config({
        debug: window.config.debug, // 开启调试模式,
        appId: res.data.data.weixinAppId, // 必填，企业号的唯一标识，此处填写企业号corpid
        timestamp: res.data.data.sign.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.data.sign.nonceStr, // 必填，生成签名的随机串
        signature: res.data.data.sign.signature, // 必填，签名，见附录1
        jsApiList: ['scanQRCode'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      })
    })

    wx.ready(function () {
      // config信息验证成功后会执行ready方法,所有接口调用都必须在config接口获得结果之后
      // config 是一个客户端的异步操作,所以如果需要在页面加载时调用相关接口,则须把相关接口放在ready函数中调用来确保正确执行.对于用户触发是才调用的接口,则可以直接调用,不需要放在ready函数中
      wx.checkJsApi({ // 判断当前客户端版本是否支持指定JS接口
        jsApiList: [
          'scanQRCode'
        ],
        success: function (res) { // 以键值对的形式返回，可用true，不可用false。如：{"checkResult":{"scanQRCode":true},"errMsg":"checkJsApi:ok"}
          if (res.checkResult.scanQRCode === true) {
          } else {
            alert('抱歉，当前客户端版本不支持扫一扫')
          }
        },
        fail: function (res) { // 检测getNetworkType该功能失败时处理
          alert('fail' + res)
        }
      })
    })

    /* 处理失败验证 */
    wx.error(function (res) {
      // config 信息验证失败会执行error函数,如签名过期导致验证失败,具体错误信息可以打开config的debug模式查看,也可以在返回的res参数中查看,对于SPA可以在这里更新签名
      alert('配置验证失败: ' + res.errMsg)
    })
  },
  methods: {
    strInsert (str, insertStr, length) {
      let reg = new RegExp('\\d{1,' + length + '}', 'g')
      let ma = str.match(reg)
      return ma.join(insertStr)
    },
    scanClick () {
      let _self = this
      wx.scanQRCode({ // 微信扫一扫接口
        desc: 'scanQRCode desc',
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
          if (result.indexOf(window.config.wxUrl) > -1) {
            let code = _self.getCode(result)
            result = window.config.scanServerUrl + code
            if (result.indexOf('?') !== -1) {
              window.location.href = result + '&publicId=' + window.config.appId
            } else {
              window.location.href = result + '?publicId=' + window.config.appId
            }
          } else if (result.indexOf(window.config.scanServerUrl) > -1) {
            if (result.indexOf('?') !== -1) {
              window.location.href = result + '&publicId=' + window.config.appId
            } else {
              window.location.href = result + '?publicId=' + window.config.appId
            }
          } else {
            setTimeout(() => {
              alert('没有此防伪码，请当心该产品是假冒产品。')
            }, 600)
          }
        },
        fail: function (res) {
          alert('扫码失败' + res)
        }
      })
    },
    getCode (url) {
      let index = url.lastIndexOf('/')
      return index > -1 ? url.substr(index) : 0
    }
  }
}
</script>

<style scoped>
  .wrap {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
  }
  .backgroundDiv {
    display: flex;
    background: url(../assets/bg.png) no-repeat;
    width: 100vw;
    height: 100vh;
    background-size: 100% 100%;
    align-items: center;
    flex-direction: column;
  }
  .topDiv {
    width:100%;
    height:20%;
    display: flex;
  }
  .titleDiv {
    height: 100%;
    width: 70%;
    display: flex;
    align-items: center;
  }
  .title {
    color: white;
    font-size: 42px;
    font-weight: 500;
    padding-left: 35px;
  }
  .logoDiv {
    height: 100%;
    width: 30%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .logo {
    width: 50px;
    height: 50px;
  }
  .middleDiv {
    width:100%;
    height: 60%;
    display: flex;
  }
  .borderDiv {
    width: 100%;
    height: 100%;
    margin: 0 35px;
    border: 1px white solid;
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    justify-content: space-around;
  }
  .scanSrc {
    width: 120px;
    height: 120px;
  }
  .scanText{
    color: #f53f58;
    font-size: 27px;
    font-weight: 500;
    letter-spacing: 0.5pt;
    line-height: 10px;
  }
  .endDiv{
    width:100%;
    height: 20%;
    display: flex;
    justify-content: center;
    overflow: hidden;
    align-items: center;
  }
  .sign {
    width: 50%;
  }
</style>

<style>
@media screen and (max-width: 750px) {
    .el-message-box {
      width: 60% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/WXScan.vue